import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20digital%20composition%20with%20flowing%20gradient%20shapes%20in%20warm%20coral%20and%20deep%20charcoal%20tones%2C%20geometric%20patterns%20subtly%20blending%2C%20modern%20minimal%20aesthetic%2C%20dark%20elegant%20atmosphere%2C%20cinematic%20lighting%2C%20smooth%20curves%2C%20high%20detail%2C%20harmonious%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="禁漫天堂 - 官方入口与完整使用指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-[var(--font-heading)] max-w-4xl">
          {siteInfo.name}
        </h1>
        <p className="text-base md:text-xl text-white/80 max-w-2xl mb-8 leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/guide"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            查看使用教程
          </Link>
          <Link
            to="/category"
            className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            浏览内容分类
          </Link>
        </div>

        <div className="mt-12 flex items-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">1,380+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">漫画作品</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">9</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">内容分类</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">50万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">活跃用户</div>
          </div>
        </div>
      </div>
    </section>
  );
}